import React from 'react';
import { Card } from 'flowbite-react';
import { D3GanttChart, D3GanttItem } from '../../components/charts/D3GanttChart';

function daysFrom(start: Date, days: number) {
  const d = new Date(start);
  d.setDate(d.getDate() + days);
  return d;
}

const base = new Date();
base.setMonth(base.getMonth() - 1);
base.setHours(0,0,0,0);

function buildScenario(): D3GanttItem[] {
  // Roughly mirrors the reference screenshot structure with bands
  const items: D3GanttItem[] = [];

  const bands = [
    { id: 'dev', label: 'Development', color: 'hsl(var(--chart-2))' },
    { id: 'test', label: 'Testing', color: 'hsl(var(--chart-3))' },
    { id: 'release', label: 'Release', color: 'hsl(var(--chart-4))' },
  ];

  // Development tasks
  items.push({
    id: 'scope', label: 'Scope', startDate: daysFrom(base, 0), endDate: daysFrom(base, 7),
    groupId: 'dev', groupLabel: 'Development', color: 'hsl(var(--chart-2))'
  });
  items.push({
    id: 'design', label: 'Design', startDate: daysFrom(base, 10), endDate: daysFrom(base, 32),
    groupId: 'dev', groupLabel: 'Development', color: 'hsl(var(--chart-2))'
  });
  items.push({
    id: 'code-freeze', label: 'Stabilize', startDate: daysFrom(base, 33), endDate: daysFrom(base, 45),
    groupId: 'dev', groupLabel: 'Development', color: 'hsl(var(--chart-2))'
  });

  // Testing stream
  items.push({
    id: 'auto-test', label: 'Automated Testing', startDate: daysFrom(base, 20), endDate: daysFrom(base, 60),
    groupId: 'test', groupLabel: 'Testing', color: '#f4b400'
  });
  items.push({
    id: 'manual-test', label: 'Manual', startDate: daysFrom(base, 36), endDate: daysFrom(base, 70),
    groupId: 'test', groupLabel: 'Testing', color: '#fbbc04'
  });

  // Release train
  items.push({
    id: 'training', label: 'Training', startDate: daysFrom(base, 55), endDate: daysFrom(base, 85),
    groupId: 'release', groupLabel: 'Release', color: '#34a853'
  });
  items.push({
    id: 'documentation', label: 'Documentation', startDate: daysFrom(base, 60), endDate: daysFrom(base, 90),
    groupId: 'release', groupLabel: 'Release', color: '#34a853'
  });
  items.push({
    id: 'pilot', label: 'Pilot', startDate: daysFrom(base, 75), endDate: daysFrom(base, 110),
    groupId: 'release', groupLabel: 'Release', color: '#34a853'
  });

  return items;
}

const scenarios: Record<string, D3GanttItem[]> = {
  'Reference-like': buildScenario(),
  'Many small tasks': Array.from({ length: 30 }, (_, i) => ({
    id: `t-${i}`,
    label: `Task ${i + 1}`,
    startDate: daysFrom(base, i),
    endDate: daysFrom(base, i + 3),
  })),
};

const GanttPlayground: React.FC = () => {
  const [scenarioKey, setScenarioKey] = React.useState<keyof typeof scenarios>('Reference-like');
  const items = scenarios[scenarioKey];

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center gap-3">
        <h1 className="text-xl font-semibold">Gantt Chart Playground</h1>
        <select
          className="bg-gray-800 text-sm rounded px-2 py-1 border border-gray-700"
          value={scenarioKey}
          onChange={(e) => setScenarioKey(e.target.value as any)}
        >
          {Object.keys(scenarios).map((k) => (
            <option key={k} value={k}>{k}</option>
          ))}
        </select>
      </div>
      <Card>
        <div className="p-2">
          <D3GanttChart
            items={items}
            title="Schedule Timeline"
            description="Playground"
            laneHeight={26}
            legendWidth={260}
          />
        </div>
      </Card>
    </div>
  );
};

export default GanttPlayground;
